// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__GU7sN","body":"style_body__2AvSA","icon":"style_icon__3XK-t"};